module.exports = __webpack_public_path__ + "img/faceai1.2c953cdb.png";